.container {
  display: flex;
  flex: 0 0 100%;
  width: 100%;
  flex-direction: row;
}

.left {
  display: flex;
  flex-direction: column;
  flex: 1 0 33%;
  padding-bottom: 40px;
}

.right {
  display: flex;
  flex: 0 1 67%;
}

.left > div {
  height: auto;
}

.subline {
  font:
    normal normal 300 1.1875rem/2rem Roboto,
    sans-serif;
}

.text {
  font:
    normal normal 300 1.0625rem/2rem Roboto,
    sans-serif;
}

.subtitle {
  font:
    normal normal bold 1.75rem/2.0625rem Rubik,
    sans-serif;
}
